import api from '@/services/api'
import store from '../index'

export default {
  state: {
    progressCourse: {
      course: null,
      showDetailsCourse: false,
      moduleSelected: null,
      lessonSelected: null,
      testSelected: false,
      certificateSelected: false,
    },
    reloadProgressCourse: false,
  },

  mutations: {
    SET_PROGRESS_COURSE(state, payload) {
      state.progressCourse = {
        course: payload.course,
        showDetailsCourse: payload.showDetailsCourse,
        moduleSelected: payload.moduleSelected,
        lessonSelected: payload.lessonSelected,
        testSelected: payload.testSelected,
        certificateSelected: payload.certificateSelected,
      }
    },

    SET_RELOAD_PROGRESS_COURSE(state, payload) {
      state.reloadProgressCourse = payload
    },
  },

  actions: {
    async initProgressCourse({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        return await api.post(`/${clientId}/courses/${courseId}/progress`)
      } catch (error) {
        throw error
      }
    },

    async getProgressCourse({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${courseId}/progress`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getProgressCourseLesson({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${data.courseId}/progress/lessons/${data.lessonId}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async doneProgressCourseLesson({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await await api.post(
          `/${clientId}/courses/${data.courseId}/progress/lessons/${data.lessonId}`,
          data.body,
        )
      } catch (error) {
        throw error
      }
    },

    async getProgressCourseTest({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${courseId}/progress/tests`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async saveProgressCourseTest({ commit }, data) {
      try {
        const { clientId } = store.getters.user

        return await await api.post(
          `/${clientId}/courses/${data.courseId}/progress/tests`,
          data.body,
        )
      } catch (error) {
        throw error
      }
    },

    async getProgressCourseCertificate({ commit }, courseId) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(
          `/${clientId}/courses/${courseId}/progress/certificate`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    setProgressCourse: ({ commit }, data) => {
      commit('SET_PROGRESS_COURSE', data)
    },

    setReloadProgressCourse: ({ commit }, status) => {
      commit('SET_RELOAD_PROGRESS_COURSE', status)
    },
  },

  getters: {
    progressCourse: (state) => state.progressCourse,
    reloadProgressCourse: (state) => state.reloadProgressCourse,
  },
}
